import React from "react"

const generalErrorMessage = <>Sorry, we are unable to proceed with your request online.
Please contact our Customer Service at <a href="tel:1800889933">1 800 889 933</a> or <a href="tel:+60321707300">+603 2170 7300</a>, operating hours 8:30am - 5.00pm (Monday to Friday) excluding public holidays. 
Alternatively, you may email your vehicle details (car plate and NRIC) to <a href="mailto:customer@bsompo.com.my">customer@bsompo.com.my</a> for further assistance.</>

export default {
  id: "BM",
  benefitsGlance: {
  title: "Manfaat anda sepintas lalu",
    desc: "Berikut adalah informasi tentang Pelan kami",
  benefit1Title: "Premium Tahunan Rendah",
    benefit1Desc: "Lindungi kandungan rumah & barang berharga anda pada premium mampu milik dengan harga daripada serendah RM66.23 setahun. Itu hanya RM0.18 sehari!",
  benefit2Title: "Barangan Rumah",
    benefit2Desc: "Ia melindungi barangan isi rumah anda dan apa-apa jenis barangan peribadi, milik anda dan ahli keluarga anda daripada kehilangan atau kerosakan yang disebabkan oleh kilat, banjir, pecah rumah dan peristiwa lain.",
  benefit3Title: "Jumlah Diinsuranskan",
    benefit3Desc: "Sehingga RM50,000 Jumlah Diinsuranskan pada kandungan isi rumah anda dan dengan 3 pelan berbeza untuk dipilih, pasti ada satu pelan yang sesuai dengan keperluan anda."
  },
  moreInsurance: {
    title: "Meliputi setiap bahagian setiap hari",
    desc: "Ketahui lebih lanjut tentang produk insurans yang kami tawarkan",
    more1Title: "Insurans Kereta",
    more1Sub1: "Perlindungan Peril Istimewa Percuma tanpa kos tambahan.",
    more1Sub2: "Nilai yang dipersetujui bagi jumlah Diinsuranskan untuk kenderaan anda.",
    more1Sub3: "Polisi semua pemandu percuma, tiada penamaan diperlukan.",
    more1Sub4_1: "Pembaharuan insurans motor",
    more1Sub4_2: "dalam talian dengan kemas kini status JPJ segera.",
    more1Sub5: "Bantuan Tepi Jalan 24 Jam.",
    more2Title: "Insurans Motosikal",
    more2Sub1: "Dapatkan sebut harga dalam talian segera dalam 1 minit.",
    more2Sub2: "Kemas kini automatik kepada sistem JPJ sebaik sahaja polisi insurans telah diperbaharui.",
    more2Sub3: "Harga yang disemak dengan kadar premium yang berpatutan.",
    more2Sub4: "Perjalanan pembelian mudah dengan sistem 100% selamat dan terjamin.",
    more3Title: "Insurans Perjalanan",
    more3Sub1: "Premium serendah RM1 sehari.",
    more3Sub2:
      "Perlindungan menyeluruh termasuk kemalangan diri, kesulitan perubatan & perjalanan.",
    more3Sub3:
      "Pelbagai pilihan pelan insurans perjalanan - pelan tunggal, kumpulan, keluarga dan tahunan.",
    more3Sub4: "24/7-365 Bantuan Perjalanan Seluruh Dunia.",
    getQuote: "Dapatkan Sebut Harga"
  },
  homeNow: {
    title: "SOMPO Home",
    desc1_1: "SOMPO Home",
    desc1_2: " ialah pelan insurans yang melindungi kandungan rumah anda terhadap kehilangan atau kerosakan akibat kebakaran, kecurian atau kemalangan. Selain itu, ia juga menawarkan perlindungan kecurian penuh di mana kecurian oleh pengunjung ke rumah anda seperti kontraktor atau pembersih sambilan turut dilindungi.",
    desc2: "Ia adalah mudah untuk membuat pembelian. Anda tidak perlu mendedahkan nilai setiap barangan di rumah anda kepada kami; hanya pilih pelan pilihan anda.",
    desc3: "Ia juga mudah untuk membuat tuntutan. Anda tidak perlu menunjukkan bukti resit untuk barangan di rumah anda. Walau bagaimanapun, jika perbuatan itu adalah jenayah, laporan polis diperlukan.",
    now: "Now"
  },
  error: {
    fieldRequired: "Sila Isi Ruang Yang Berkenaan",
    validNRIC: "Sila Isikan Nombor Kad Pengenalan Yang Sah",
    validEmail: "Sila masukkan e-mel yang sah",
    validPostcode: "Poskod tidak sah",
    validAgeFactor: "Maaf, kami tidak dapat menawarkan perlindungan kerana umur anda tidak memenuhi syarat kelayakan kami yang ditetapkan.",
    validBMI: "Terima kasih kerana berminat dengan SOMPO HomeNow. Kami tidak dapat meneruskan pembelian anda dalam talian kerana Indeks Jisim Badan (BMI) anda tidak memenuhi syarat pengunderaitan kami yang ditetapkan.",
    validPhoneNo: "Sila masukkan nombor telefon yang sah",
    amlaError: "Maaf, kami tidak dapat meneruskan transaksi anda. Sila hubungi Khidmat Pelanggan kami di +603 2170 7300, waktu operasi 8.30 pagi - 5.00 petang (Isnin hingga Jumaat) tidak termasuk cuti umum. Anda juga boleh menghantar e-mel ke customer@bsompo.com.my untuk mendapatkan bantuan lanjut.",
    errorOccured: "Ralat telah berlaku!",
    notEligible1: "Anda tidak memenuhi syarat kelayakan untuk produk ini. Untuk bantuan lanjut, sila hubungi kami di ",
    notEligible2: " atau e-mel kami di "
  },
  productLinks: {
    motorNow: "https://online.berjayasompo.com.my/SompoMotor/bm/",
    motorSafe: "https://online.berjayasompo.com.my/SompoMotor/bm/MotorSafe",
    medicNow: "https://online.berjayasompo.com.my/medicNow/insurans-perubatan/",
    motorcycle: "https://online.berjayasompo.com.my/motorcycle/bm/",
    cashNow: "https://online.berjayasompo.com.my/cashNow/insurans-pendapatan-hospital/",
    homeNow: "https://online.berjayasompo.com.my/homeNow/insurans-kandungan-rumah/",
    travel: "https://online.berjayasompo.com.my/travel-insurance/insurans-perjalanan/"
  },
  contact: {
    title: "Perlukan bantuan? Hubungi Kami",
    description: "Hubungi kami untuk bantuan dengan polisi anda, membuat tuntutan dan pembelian insurans.",
    registrationNo: "Nombor Pendaftaran"
  },
  footer: {
    title: "Pengaki",
    onlineProduct: "PRODUK DALAM TALIAN",
    onlineCarIns: "Insurans Kereta Dalam Talian",
    onlineCarInsSafe: "Insurans Kereta Dalam Talian (Berdasarkan Jarak Tempuh)",
    onlineMotorCycleIns: "Insurans Motosikal Dalam Talian",	
    onlineTravelIns: "Insurans Perjalanan Dalam Talian",
    onlineCashNowIns: "Insurans Pendapatan Hospital Dalam Talian",
    onlineMedicNowIns: "Insurans Perubatan & Kesihatan Dalam Talian",	
    onlineHomeNowIns: "Insurans Kandungan Rumah Dalam Talian",
    keyDownload: "MUAT TURUN UTAMA",	
    pds: "Lembaran Pendedahan Produk",	
    pwt: "Susunan Kata Polisi",		
    contactUs: "HUBUNGI KAMI",	
    address: "Alamat",
    cs: "Khidmat Pelanggan",
    time: "8:30 PG - 5:00 PTG (Isnin hingga Jumaat)",
    tel1: "1 800 889 933 (dalam Malaysia)",	
    tel2: "+603 2170 7300 (luar negara)",
    worldWideAssistance: "Bantuan 24/7 Seluruh Dunia",
    breakDownForPrivateCar: "Servis Kerosakan 24/7 untuk Kereta Persendirian",
    breakDownForMotorcycle: "Servis Kerosakan 24/7 untuk Motosikal"
  },  
  generalErrorMessage: generalErrorMessage,
  errorMessages: [
    {
      apiError: "general",
      message: generalErrorMessage
    },
    {
      apiError: "ISM Connectivity Error",
      message: generalErrorMessage
    },
    {
      apiError: "[INVALID PERMANENT POST CODE]",
      message: "Invalid Post Code!"
    },
    {
      apiError: "UW Policy holder Age Referred",
      message: generalErrorMessage
    },
    {
      apiError: "POLICY LAPSED DAYS SHOULD NOT BE MORE THAN 14 DAYS",
      message: generalErrorMessage
    },
    {
      // TP to comprehensive
      apiError: "1 - Scope of Cover changed from Third Party to Comprehensive Referred $$UW Sum Insured Referred",
      message: generalErrorMessage
    },
    {
      apiError: "UW Sum Insured Referred",
      message: generalErrorMessage
    },
    {
      // a case of high perf vehicle got this error
      apiError: "MAKE MODEL MISSING",
      message: generalErrorMessage
    },
    {
      apiError: "sessionExpired",
      message: "Your session has expired. Please retry from beginning"
    },
    {
      apiError: "POLICY SHOULD BE LESS THAN 60 DAYS TO TAKE THE EARLIER POLICY",
      message: "POLICY SHOULD BE LESS THAN 60 DAYS TO TAKE THE EARLIER POLICY"
    },
    {
      apiError: "INVALID VEHICLE MAKE MODEL",
      message: "INVALID VEHICLE MAKE MODEL"
    },
    {
      apiError: "Pricing Field Error",
      message: <>We are currently unable to process your quotation. Please try quoting at our alternate site at <a href="https://customer.berjayasompo.com.my/directsales/motor-cycle/">https://customer.berjayasompo.com.my/directsales/motor-cycle/</a></>
    }
  ],
  sompoHome: "SOMPO Home",
  now: "Now",
  home: "Laman Utama",
  howToClaim: "Cara Menuntut",
  contactUs: "Hubungi Kami",
  partnerWithUs: "Bekerjasama Dengan Kami",
  partnerWithUsLink: "https://online.berjayasompo.com.my/partner-with-us/",
  homeLink: "https://online.berjayasompo.com.my/homeNow/insurans-kandungan-rumah/",
  onlineProduct: "Produk Dalam Talian",
  extraCoverage: "PERLINDUNGAN TAMBAHAN UNTUK VAKSINASI PASCA COVID-19 TANPA KOS (BARU)",
  homeBannerWord: "Adakah barangan peribadi anda dilindungi?",
  step1: "Langkah 1",
  step2: "Langkah 2",
  step3: "Langkah 3",
  plan: "Pelan",
  details: "Butiran",
  payment: "Bayaran",
  lite: "Lite",
  Basic: "Basic",
  Prime: "Prime",
  annual: "Tahunan",
  coverage: "Liputan pada semua kandungan isi rumah",
  limitPerItem: "Had setiap item",
  buyNow: "Beli sekarang",
  policyDetails: "Butiran Pemegang Polisi",
  fillDetailsBelow: "Sila isikan butiran anda di bawah",
  name: "Nama (Mengikut Kad Pengenalan)",
  nric: "Kad Pengenalan",
  nationality: "Kewarganegaraan",
  nricPassport: "Kad Pengenalan/Pasport",
  dob: "Tarikh Lahir",
  dob2: "Tarikh Lahir",
  emailAddress: "Alamat E-mel",
  phone: "No. Telefon",
  propertyDetails: "Butiran Harta",
  selectCoveragePeriod: "Sila pilih tempoh perlindungan",
  startDate: "Tarikh Mula Polisi",
  endDate: "Tarikh Tamat Polisi",
  propertyNotice: "Pembinaan kediaman persendirian batu bata/dinding konkrit, pintu konkrit bertetulang dan beratap jubin/konkrit/asbestos",
  address1: "Alamat 1",
  address2: "Alamat 2",
  postcode: "Poskod",
  state: "Negeri",
  propertyTerms: "Berkenaan dengan risiko yang dilindungi, pernahkah anda mengalami apa-apa kerugian atau sebarang tuntutan dalam tempoh 3 tahun yang lalu atau insurans telah ditolak, dibatalkan, ditolak pembaharuan, tertakluk kepada terma khas atau peningkatan premium oleh mana-mana syarikat insurans lain?",
  yes: "Ya",
  no: "Tidak",
  selectAnswer: "Sila isikan pilihan anda",
  back: "Kembali",
  next: "Seterusnya",
  quotationSummary: "Ringkasan Sebut harga",
  typeOfPlan: "Jenis Pelan",
  periodOfInsurance: "Tempoh Insurans",
  grossPremium: "Premium Kasar",
  rebate: "Rebat",
  grossPremiumAfterRebate: "Premium Kasar Selepas Rebat",
  serviceTax: "Cukai Perkhidmatan",
  stampDuty: "Duti Setem",
  totalAnnualPremium: "Jumlah Premium Tahunan",
  summaryNPayment: "Ringkasan & Pembayaran",
  infoConfimation: "Sila semak dan sahkan maklumat di bawah",
  policyHolderDetails: "Butiran Pemegang Polisi",
  quotationDetails: "Butiran Sebutharga",
  coveragePeriod: "Tempoh Perlindungan",
  propertyAddress: "Alamat Harta",
  declare1: "Saya/Kami telah membaca, memahami dan mengakui ",
  declare2: " dan",
  declare3: "dan dengan ini membenarkan penggunaan dan pemprosesan Data Peribadi saya/kami oleh Kumpulan Syarikat Sompo dan Kumpulan Syarikat Berjaya (di dalam atau di luar Malaysia) untuk tujuan tersebut seperti yang diterangkan dalam Notis Privasi.",
  declare4: "Saya/Kami dengan ini mengakui bahawa semua maklumat yang diberikan adalah benar dan saya/kami tidak menyimpan sebarang maklumat yang mungkin mempengaruhi penerimaan cadangan ini. Saya/Kami mengakui bahawa terma kontrak utama telah dijelaskan dengan secukupnya kepada saya/kami dan saya/kami memahami sepenuhnya terma tersebut. Saya/kami berpuas hati bahawa produk tersebut memenuhi keperluan insurans saya/kami dan kemampuan kewangan.",
  declare5: "Notis Privasi",
  declare6: "Lembaran Pendedahan Produk",
  acceptTermsNCondition: "Saya menerima terma dan syarat",
  pleaseAcceptTNC: "Sila terima terma dan syarat",
  payNow: "Bayar Sekarang",
  paymentSuccess: "Pembayaran Berjaya",
  thankYouPayment1: "Terima kasih kerana memilih pelan insurans Home",
  thankYouPayment2: "Now",
  thankYouPayment3: ".Pembayaran anda telah berjaya diproses.",
  failedPayment1: "Terima kasih kerana memilih pelan insurans SOMPO Home",
  failedPayment2: "Now",
  failedPayment3: ". Akan tetapi, pembayaran anda tidak berjaya. Sila cuba membuat bayaran semula.",
  transactionDetails: "Butiran Transaksi",
  transactionNo: "No. Transaksi",
  transactionDate: "Tarikh Transaksi",
  paymentMethod: "Kaedah Pembayaran",
  totalAmount: "Jumlah Keseluruhan",
  paymentName: "Nama",
  typeOfPlan: "Jenis Pelan",
  policyNo: "No. Polisi",
  paymentFailed: "Pembayaran Tidak Berjaya",
  periodOfInsurance: "Tempoh Insurans",
  periodOfCover: "Tempoh Insurans",
  to: "sampai",
  paymentRetry: "Bayar Sekarang",
  policyEmailPre: "Salinan resit dan Jadual Polisi anda akan dihantar ke alamat e-mel anda di",
  policyEmailPost: "Sila semak folder e-mel sampah atau spam jika anda tidak menerima dokumen dalam peti masuk anda.",
  crossCar: "https://online.berjayasompo.com.my/SompoMotor/bm/",
  crossCarImage: "/homeNow/images/img-cross-motor-bm.jpg",
  crossMotor: "https://online.berjayasompo.com.my/motorcycle/bm/",
  crossMotorImage: "/homeNow/images/img-cross-motorcycle-bm.jpg",
  crossTravel: "https://online.berjayasompo.com.my/travel-insurance/insurans-perjalanan/",
  crossTravelImage: "/homeNow/images/img-cross-travel-bm.jpg",
  PDS: "/homeNow/docs/PDS_SOMPO HomeNow_BM_0324.pdf",
  PW: "/homeNow/docs/SOMPO Home Now PW BM Ver_Finalized (003).pdf",
  downloadCI:"Muat Turn Polisi",
  downloadDesc:"Anda juga boleh memuat turun resit dan jadual polisi pada butang muat turun di atas. Sila ambil perhatian bahawa pautan butang muat turun akan tamat tempoh dalam masa 15 minit.",
  encryptionDesc:"To open the file, please use the following password format: the first initials of your name (as stated in the policy) incapital letters, followed by the last 6 digits of your NRIC/Passport number.",
  encryptionExp:"For example: If your name is John and the last 6 digits of your NRIC are 141234, your password will be J141234."
}